<div #mapEl class="map-container border-b border-gray-medium dark:border-dark-border shadow-sm"></div>
